"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const styles_1 = require("@material-ui/core/styles");
exports.useStyles = makeStyles_1.default((theme) => {
    var _a, _b;
    return ({
        menu: {
            color: 'rgb(66, 66, 66)',
            backgroundColor: 'white',
            maxWidth: 'calc(100vw - 62px)',
            height: 29,
        },
        menuItemsWrapper: {
            display: 'inline-block',
            whiteSpace: 'nowrap',
            width: '100%',
            overflow: 'auto',
        },
        menuItem: {
            display: 'inline-block',
            padding: '4px 10px',
            overflow: 'visible',
            transition: 'none',
        },
        menuItemText: {
            fontWeight: 400,
            fontSize: 14,
            letterSpacing: 0.2,
        },
        activeMenuItem: {
            position: 'relative',
            '&:after': {
                position: 'absolute',
                height: 2,
                right: 4,
                bottom: 0,
                left: 4,
                content: "''",
                backgroundColor: theme.palette.primary.main,
            },
        },
        subMenu: {
            backgroundColor: 'white',
            top: 0,
            zIndex: 5,
            boxShadow: (_a = theme === null || theme === void 0 ? void 0 : theme.eas) === null || _a === void 0 ? void 0 : _a.shadow[1],
            borderRadius: (_b = theme.eas) === null || _b === void 0 ? void 0 : _b.radius,
            maxHeight: 'calc(100vh - 80px)',
            overflowY: 'auto',
        },
        subHeader: {
            fontWeight: 600,
            cursor: 'initial',
            color: 'black',
        },
        subHeaderLink: {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: styles_1.darken('#ffffff', theme.palette.action.hoverOpacity),
            },
        },
        subMenuTopLevel: {
            left: 0,
            top: 1,
        },
        subMenuItem: {
            overflow: 'visible',
            minWidth: 200,
            transition: 'none',
        },
        subMenuItemText: {
            fontWeight: 400,
            fontSize: 14,
            letterSpacing: 0.2,
        },
        subMenuAction: {
            fontSize: '0.875rem !important',
            color: '#7c7c7c',
            height: 20,
            right: 10,
            display: 'flex',
        },
        subMenuArrow: {
            fontSize: '0.875rem !important',
        },
        shortcut: {
            height: 20,
        },
    });
});
//# sourceMappingURL=menu-styles.js.map